import './Footer.scss';

import View                    from '@widesk-ui/components/View';
import { FOOTER_HEIGHT }       from '@/TokamapEditor/ux/constants';
import useDesignTokens         from '@/hooks/useDesignTokens';
import leftSidebarStore        from '@/TokamapEditor/stores/leftSidebarStore';
import { observer }            from 'mobx-react-lite';
import PlaceModel              from '@models/map/PlaceModel';
import PlaceTypeModel          from '@models/map/PlaceTypeModel';
import Menu                    from '@widesk-ui/Menu';
import { MenuProps }           from '@widesk-ui/Menu';
import { EnvironmentOutlined } from '@ant-design/icons';
import { TagsOutlined }        from '@ant-design/icons';
import { BgColorsOutlined }    from '@ant-design/icons';
import currentEditorStore      from '@/TokamapEditor/stores/currentEditorStore';

type MenuItem = Required<MenuProps>['items'][number];

const items: MenuItem[] = [
	{
		key: 'places',
		icon: <EnvironmentOutlined />,
		label: PlaceModel.localize('plural'),
		onClick: () => {
			if (leftSidebarStore.options.reference === 'places') return leftSidebarStore.close();
			return leftSidebarStore.openPlaces();
		},
	},
	{
		key: 'place_types',
		icon: <TagsOutlined />,
		label: PlaceTypeModel.localize('plural'),
		onClick: () => {
			if (leftSidebarStore.options.reference === 'place_types') return leftSidebarStore.close();
			return leftSidebarStore.openPlaceTypes();
		},
	},
	{
		key: 'themes',
		icon: <BgColorsOutlined />,
		// TODO Remplacer par `ThemeModel.localize('plural')` quand le modèle existera.
		label: 'Thèmes',
		onClick: () => {
			if (leftSidebarStore.options.reference === 'themes') return leftSidebarStore.close();
			return leftSidebarStore.openThemes();
		},
	},
];

const Footer = observer(() => {
	const tokens = useDesignTokens();
	const selectedKeys = (() => {
		const arr = [];

		if (leftSidebarStore.options.reference === 'places') arr.push('places');
		if (leftSidebarStore.options.reference === 'place_types') arr.push('place_types');
		if (leftSidebarStore.options.reference === 'fields') arr.push('fields');
		if (leftSidebarStore.options.reference === 'themes') arr.push('themes');

		return arr;
	})();

	if (!currentEditorStore.isCenterDefined) return null;

	return (
		<View
			h={FOOTER_HEIGHT}
			bg={tokens.surface.card}
			centerV
			p="sm"
			style={{ borderTop: `1px solid ${tokens.border.subtle}`, userSelect: 'none' }}
			row
			gap="sm"
			spread
			zIndex={1003}
		>
			<View id="bottom-menu-bar" w={250} flex={1}>
				<Menu
					items={items}
					mode="horizontal"
					selectedKeys={selectedKeys}
				/>
			</View>
		</View>
	);
});

export default Footer;